/**
 * The breaks a roster PDF prints. The PDF's "#" cells are read into the roster template as -1 slots
 * (backend/config.py: BREAK_SLOT), and the template is kept with the session (last_inputs.roster_template).
 * The officer grid draws these exactly as printed, instead of inferring breaks from the gaps between an
 * officer's counters — an inference that misses a break at the edge of a stretch of SOS or booth duty.
 */
import type { RosterDuties, RosterTemplate } from '@/types/api';

/**
 * Officer key ("SN12") → the slots the PDF prints as a break for that S/N. The template also holds the
 * stretches printed as a non-counter deployment ("SOS", "B@M CTRL BOOTH") as -1, off the counters —
 * those are `duties`, not breaks, so they are left out: once the deployment is taken off the officer, that
 * time is available time, not a break.
 */
export function printedBreakSlots(
  template: RosterTemplate | null | undefined,
  duties?: RosterDuties | null,
): Record<string, number[]> {
  const out: Record<string, number[]> = {};
  for (const [sn, slots] of Object.entries(template ?? {})) {
    const printedDuty = duties?.[sn] ?? {};
    const breaks = slots.flatMap((v, k) => (v === -1 && !(String(k) in printedDuty) ? [k] : []));
    if (breaks.length > 0) out[`SN${sn}`] = breaks;
  }
  return out;
}
